/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



(function ($, window) {
    "use strict";
    var revivJs = {
        m: function () {
            revivJs.d();
            revivJs.methods();
        },
        d: function () {
            this._window = $(window);
            this._document = $(document);
            this._body = $("body");
            this._html = $("html");
        },
        methods: function () {
            this.slickActivation();
            this.accordionActivation();
        },
        // start slick activation
        slickActivation: function () {

            // card-slider start

            if ($(Window).width() < 768) {
                $('.card-slider__items').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                });
            }

            $('.card-slider__right-arrow').click(function () {
                $(this).parent().parent().find('.slick-slider').slick('slickNext');
            });


            if ($(Window).width() < 768) {
                $('.text-slider__items').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                });
            }

            $('.text-slider__right-arrow').click(function () {
                $(this).parent().parent().find('.slick-slider').slick('slickNext');
            });
            // card-slider end

        },
        // end slick activation




        // start accordion activation
        accordionActivation: function () {
            function initAccordion() {
                if ($(window).width() < 1024) {
                    $(".accordion__content").hide();
                    $(".accordion:first .accordion__content").show();
                    $(".accordion:first .accordion__title").addClass("active");

                    $(".accordion__title").off("click").on("click", function () {
                        if (!$(this).hasClass("active")) {
                            $(".accordion__content").slideUp(300);
                            $(".accordion__title").removeClass("active");
                            $(this).addClass("active").next(".accordion__content").slideDown(300);
                        } else {
                            $(this).removeClass("active").next(".accordion__content").slideUp(300);
                        }
                    });
                } else {
                    $(".accordion__content").show();
                    $(".accordion__title").removeClass("active").off("click");
                }
            }

            initAccordion();

            $(window).on("resize", function () {
                initAccordion();
            });
        },
        // End accordion activation


    };
    revivJs.m();
})(jQuery, window);


if ($(Window).width() < 768) {
    $('.inside__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
    $('.inside__right-arrow').click(function () {
        $(this).parent().parent().find('.slick-slider').slick('slickNext');
    });
}


$(".collapse-item__title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".collapse-item__content").slideUp();
    } else {
        $(".collapse-item__content").slideUp();
        $(".collapse-item__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".collapse-item__content").slideDown();
    }
})



// ---------------------cart start-----------------



$('.cart__product-add-items').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: false
});


// $(".hidden-tablet-and-up").on('click', function () {
//     $("body").addClass('cart-open');
// })
// $(".cart__top-cross-img").on('click', function () {
//     $("body").removeClass('cart-open');
// })
// ---------------------cart end-----------------





$('.main-product__img-poster').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.main-product__thumb',
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});
$('.main-product__thumb').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.main-product__img-poster',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    vertical: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                vertical: false,
            }
        },
    ]
});
$('.main-product__slider-next').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.main-product__slider-prev').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// Product page and cart

$(document).ready(function() {
    $('.dv-custom-cart-tigger').on('click', function(){
        $('.dv-custom-cart').addClass('active');
        $('.c_cart_drawer_overlay').addClass('active');
    })
    $('.c_cart_drawer_overlay').on('click', function(){
        $('.dv-custom-cart').removeClass('active');
        $(this).removeClass('active');
    })
    $('.cart__top-cross-img').on('click', function(){
        $('.dv-custom-cart').removeClass('active');
        $('.c_cart_drawer_overlay').removeClass('active');
    })
    $('#qty-plus').on('click', function() {
        let $input = $('#qtynumber');
        let currentVal = parseInt($input.val()) || 1;
        $input.val(currentVal + 1).trigger('change');
        updateDisplayedPrice();
        handleAddonQty()
    });
    $('#qty-minus').on('click', function() {
        let $input = $('#qtynumber');
        let currentVal = parseInt($input.val()) || 1;
        if (currentVal > 1) {
        $input.val(currentVal - 1).trigger('change');
        } else {
        $input.val(1).trigger('change');
        }
        updateDisplayedPrice();
        handleAddonQty()
    });


    // --- Upsell Cart Drawer Offer Logic ---
    $(document).on('click', '.product-offer-add-to-cart-button', function() {
        setTimeout(function() {
            cartUpdate();
        }, 800);
    });

    $(document).on('click', '.cart-drawer-upsell-offer .quantity__button', function(e) {
        e.preventDefault();
        
        var $input = $(this).closest('.quantity').find('input.upsell-cart-drawer-bold-quantity-input');
        var currentVal = parseInt($input.val()) || 1;
        
        if ($(this).attr('name') === 'plus') {
            $input.val(currentVal + 1);
        } else {
            if (currentVal > 1) {
                $input.val(currentVal - 1);
            }
        }
        
        $input.trigger('change');
    });


    var addQty = 1;
    let selectedVariantId = $('input[name="seram"]:checked').data('variantid');
    let selectedVariantPrice = $('input[name="seram"]:checked').data('price') || 0;
    let selectedVariantComPrice = $('input[name="seram"]:checked').data('comprice') || 0;
    $(document).on('change', 'input[name="seram"]', function () {
        var qtyVal = parseInt($('#qtynumber').val()) || 1;
        selectedVariantId = $(this).data('variantid');
        selectedVariantPrice = parseFloat($(this).data('price')) || 0;
        selectedVariantComPrice = parseFloat($(this).data('comprice')) || 0;
        addQty = parseInt($(this).attr('addonquantity'), 10) || 1;
        var setAddQty = Math.min(9, Math.max(1, addQty * qtyVal));
        $('.quantity-select').val(String(setAddQty));
        updateDisplayedPrice();
    });


    $(document).on('change', '.cproductaddon', function () {
        updateDisplayedPrice();
    });

    function handleAddonQty(){
        var multiplier = parseInt($('#qtynumber').val()) || 1;
        console.log('quantity is:' + multiplier);
        $('.quantity-select').each(function () {
        // var currentVal = parseInt($(this).val(), 10) || 0;
        var currentVal = addQty;
        var newVal = currentVal * multiplier;
        console.log('Addon qty:' + newVal);
        $(this).val(newVal).trigger('change');
        });
    }



    function formatMoney(cents) {
    const moneyFormat = window.Shopify?.currency?.active === 'USD' ? '${{amount}}' : '{{amount}}';
    let value = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', value);
    }
    function updateDisplayedPrice() {
        const quantity = parseInt($('#qtynumber').val()) || 1;

        let totalPrice = selectedVariantPrice * quantity;
        let totalComPrice = selectedVariantComPrice * quantity;
        $('.cproductaddon:checked').each(function () {
            const addonQty = $(this).next().find('.quantity-select').val() || 1;
            const addonPrice = parseFloat($(this).data('price')) || 0;
            const totalAddonPrice = addonPrice * addonQty;
            totalPrice += totalAddonPrice;
            totalComPrice += totalAddonPrice;
        });

            var priceDiff = totalComPrice - totalPrice;
            var saveprice = priceDiff * 100 / totalComPrice;
            var formatSave = Math.round(saveprice);
            if(selectedVariantComPrice >= 1){
                $('.save-badge').show();
                $('.save-badge').text('Save ' + formatSave +'%');
            }else{
                $('.save-badge').text('');
                $('.save-badge').hide();
            }
            

        const formattedPrice = formatMoney(totalPrice * 100);
        const formattedComPrice = formatMoney(totalComPrice * 100);
        $('.prod-main-price span').text(formattedPrice);
        if(selectedVariantComPrice >= 1){
            $('.compare-price span').text(formattedComPrice);
        }else{
            $('.compare-price span').text('');
        }
        
        console.log(totalPrice)
        
    }

$('.quantity-select').on('change', function(){
    updateDisplayedPrice();
})




// Cart add on slider

    $(document).on('click', '.cart_addon_product_btn', function(e){
        e.preventDefault();
        var addOnId = $(this).data('addonid');
        if (!addOnId) {
            console.error("No addon ID found on button", this);
            return;
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({
                id: addOnId,
                quantity: 1
            }),
            dataType: 'json',
            contentType: 'application/json',
            success: function (data) {
                cartUpdate();
            },
            error: function (err) {
                console.error("Error adding Addon product:", err);
            }
        });
    });

    function cartAddonCheck() {
}


// Add to cart logic

$('.addtocartbtn').on('click', async function(e) {
    e.preventDefault();
    const quantity = parseInt($('#qtynumber').val()) || 1;
    if (!selectedVariantId) {
        alert('Please select a product variant!');
        return;
    }
    const mainProduct = {
        id: selectedVariantId,
        quantity: quantity,
        properties: {}
    };
    $('.cproductproperties:checked').each(function() {
        const key = $(this).data('properties-name');
        const value = "(included)";
        mainProduct.properties[key] = value;
    });
    const items = [
        mainProduct
    ];
    $('.cproductaddon:checked').each(function() {
        items.push({
            id: $(this).data('addonid'),
            quantity: $(this).next().find('.quantity-select').val(),
            parent_id: selectedVariantId
        });
    });
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
        });
        if (!response.ok) {
            const error = await response.json();
            console.error('Error adding items:', error);
            return;
        }
        const data = await response.json();
        cartUpdate();
    } catch (err) {
        console.error('AJAX error:', err);
    }
});






// Remove item from cart



$(document).on('click', '.cart__product-delete-img', function(e) {
  e.preventDefault();
  var itemKey = $(this).data('itemproductid');

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: itemKey, quantity: 0 },
    dataType: 'json',
    success: function(cart) {
      cartUpdate();
    },
    error: function(err) {
      console.error('Error removing item:', err);
    }
  });
});





// Cart Quantity Update logic
$(document).on('click', '.cart-qty-minus', function() {
  let input = $(this).siblings('.cart-qty-input');
  let currentQty = parseInt(input.val()) || 1;
  let newQty = Math.max(1, currentQty - 1);
  input.val(newQty).trigger('change');
});
$(document).on('click', '.cart-qty-plus', function() {
  let input = $(this).siblings('.cart-qty-input');
  let currentQty = parseInt(input.val()) || 1;
  let newQty = currentQty + 1;
  input.val(newQty).trigger('change');
});
$(document).on('change', '.cart-qty-input', function() {
  let newQty = parseInt($(this).val()) || 1;
  let itemKey = $(this).data('itemkey');
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: itemKey, quantity: newQty },
    dataType: 'json',
    success: function(cart) {
      cartUpdate();
    },
    error: function(err) {
      console.error('Error updating quantity:', err);
    }
  });
});


// Cart Update Logic

function cartUpdate() {
    $.getJSON('/cart.js', function(cart) {
    var cartDrawer = $('.dv-custom-cart');
    var cartDrawerOverlay = $('.c_cart_drawer_overlay');
    cartDrawer.addClass('active');
    cartDrawerOverlay.addClass('active');
    $('.cart_item_count').text(cart.item_count);
    cartUpdateData();
  });
}
function cartUpdateData() {
  fetch('/?section_id=dv-custom-cart')
    .then(response => response.text())
    .then(cartData => {
        setTimeout(function() {
            if (typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
                BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
            }
        }, 200);
      var cartHtml = $(cartData);
      var cartWrapper = $('.cart__wrapper', cartHtml);
      $('.cart__wrapper').replaceWith(cartWrapper);
        if ($('.cart__product-add-items').length) {
        $('.cart__product-add-items').slick({
          dots: true,
          arrows: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: false
        });
      }
    })
    .catch(err => console.error("Error while updating", err));
}
});










// result start


$('.result__items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
});

$('.result__prev-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.result__next-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// result end


// Start formula accordion
$(".formula__faq-header").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".formula__faq-content").slideUp();
    } else {
        $(".formula__faq-content").slideUp();
        $(".formula__faq-header").removeClass("active");
        $(this).addClass("active");
        $(this).next(".formula__faq-content").slideDown();
    }
})

// end formula accordion



// Start Video Play Pos Formula Area
$('.formula__video-btn').on('click', function () {
    const video = $('.formula__video video').get(0);
    video.play();
    $(this).hide();
    video.setAttribute('autoplay', true);
});
$('.formula__video video').on('click', function () {
    if (this.paused) {
        this.play();
        $('.formula__video-btn').hide();
    } else {
        this.pause();
        $('.formula__video-btn').show();
        this.removeAttribute('autoplay');
    }
})



// collection-product start


if ($(Window).width() < 768) {
    $('.collection-product__wrap').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}


// collection-product end



// popup start


$(".redensyl-power__right").on('click', function () {
    $('body').addClass('popup-show');
})
$(".popup__close").on('click', function () {
    $('body').removeClass('popup-show');
})


// popup end





// Start Update Js 10/13/2025


// Slider For Product Page Testimonial
if ($(Window).width() < 768) {
    $('.testimonial__items, .why-wrok__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
    $('.testimonial__right-arrow, .why-wrok__right-arrow').click(function () {
        $(this).parent().parent().find('.slick-slider').slick('slickNext');
    });
}

// Start Video Play on 
$(document).ready(function() {
    $('.testimonial-card__img').on('click', function() {
        var $videoContainer = $(this); 
        var $video = $videoContainer.find('video'); 
        var $playBtn = $videoContainer.find('.testimonial-card__playbtn'); 
        var isPlaying = $video.attr('playsinline') !== undefined;
        if (isPlaying) {
            $video[0].pause();
            $video.removeAttr('playsinline');
            $video.removeAttr('loop');
            $playBtn.show();
        } else {
            $('.testimonial-card__img').each(function() {
                var $otherVideo = $(this).find('video');
                var $otherPlayBtn = $(this).find('.testimonial-card__playbtn');
                if ($otherVideo.attr('playsinline') !== undefined && $otherVideo[0] !== $video[0]) {
                    $otherVideo[0].pause();
                    $otherVideo.removeAttr('playsinline');
                    $otherVideo.removeAttr('loop');
                    $otherPlayBtn.show();
                }
            });
            $video.attr('playsinline', 'playsinline');
            $video.attr('loop', 'loop'); 
            $video[0].play(); 
            $playBtn.hide(); 
        }
    });
    $('.testimonial-card__playbtn').on('click', function(e) {
        e.stopPropagation();
        $(this).closest('.testimonial-card__img').trigger('click');
    });
});




// Start Study Details Blacked
$(".why-work__study-header").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".why-work__study-content").slideUp();
    } else {
        $(".why-work__study-content").slideUp();
        $(".why-work__study-header").removeClass("active");
        $(this).addClass("active");
        $(this).next(".why-work__study-content").slideDown();
    }
})



$('.inside-card > a').on('click', function () {
    $("body").addClass('popup-shows');
    var popup_title = $(this).data('title');
    var popup_content = $(this).data('content');
    var popup_image = $(this).data('img');
    var popup_video = $(this).data('video');
    $('.inside-popup__top h2').text(popup_title);
    $('.inside-popup__text').html(popup_content);
    console.log(popup_image);
    if(popup_image != ''){
        $('.inside-popup__img').show();
        $('.inside-popup__img img').attr('src', popup_image);
    }else{
        $('.inside-popup__img').hide();
    };

    if(popup_video != ''){
        $('.inside-popup__video').show();
        let videoId = "";
        if (popup_video.includes("watch?v=")) {
            videoId = popup_video.split("v=")[1].split("&")[0];
        }
        else if (popup_video.includes("youtu.be/")) {
            videoId = popup_video.split("youtu.be/")[1].split("?")[0];
        }
        $('.inside-popup__video iframe').attr('src', "https://www.youtube.com/embed/" + videoId);
    }else{
        $('.inside-popup__video').hide();
    }
});
$('.inside-popup__close , .overlay-bg').on('click', function () {
    $("body").removeClass('popup-shows');
});
// Start Popup Video Open
$(document).ready(function () {
    $(".inside-popup__video").each(function () {
        const $container = $(this);
        const $video = $container.find("video");
        const $playBtn = $container.find(".inside-popup__video-btn");
        $playBtn.on("click", function () {
            $video.prop("muted", false);
            $video.get(0).play();
            $playBtn.hide();
        });
        $video.on("click", function () {
            if (this.paused) {
                this.play();
                $video.prop("muted", false);
                $playBtn.hide();
            } else {
                this.pause();
                $playBtn.show();
            }
        });
    });
});
